function cubicIn(t) {
  return t * t * t
}

module.exports = cubicIn